// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MLmel","colBig":"styles_colBig__M-QXu","colSmall":"styles_colSmall__2bbjV"};